import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const saved = typeof localStorage !== "undefined" ? localStorage.getItem("wmt_token") : null;
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

export const setToken = (token) => {
  localStorage.setItem("wmt_token", token);
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const clearToken = () => {
  localStorage.removeItem("wmt_token");
  delete api.defaults.headers.common["Authorization"];
};

export const getToken = () => localStorage.getItem("wmt_token");

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}
